import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { useSearchParams } from "react-router-dom";

import naturalSort from "javascript-natural-sort";

import moment from "moment";

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";
import copyTextToClipboard from "../libs/copyTextToClipboard.jsx";
import Loader from "../libs/loader.jsx";
import Notification from "../libs/notification.jsx";
import Announcements from "../libs/announcements.jsx";

import { Button, VirtualizedList, Link, Tooltip, Table, TableHeader, TableHeaderCell, TableBody, TableVirtualizedBody, TableRow, TableCell, Flex, Divider, Search, ButtonGroup, Dropdown, MenuButton, Menu, MenuItem } from "@vibe/core";
import { Edit, Add, Duplicate, File, Info, ExternalPage, Basic, Share, Delete, Versioning } from "@vibe/icons";

import DatasetDiagram from './diagram.jsx';
import FlushDatasetCache from './flush_dataset_cache.jsx';
import DatasetDelete from './delete.jsx';
import DatasetClone from './clone.jsx';
import DatasetShare from './share.jsx';

import Monday from "../auth/useMonday.jsx";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

class DatasetList extends React.Component
{
    constructor(props)
    {
        super(props);
        var this_component = this;

        const search = Object.fromEntries(this_component.props.router.search.entries());
        
        //console.log("DatasetList props:", {props}, {...this_component.props}, search  );
        
        this_component.user = this_component.props.auth.user;
        
        this_component.tableColumns = [
            {id: 'name', loadingStateType: 'medium-text', title: 'Name', sort: 'none'},
            {id: 'user_name', loadingStateType: 'medium-text', title: 'Owner', width: 250, sort: 'none'},
            {id: 'created_at', loadingStateType: 'medium-text', title: 'Created', width: 160, sort: 'desc'},
            {id: 'updated_at', loadingStateType: 'medium-text', title: 'Modified', width: 160, sort: 'none'},
            {id: 'description', loadingStateType: 'long-text', title: 'Description', sort: null},
            {id: 'url', loadingStateType: 'long-text', title: 'URL', sort: null},
            {id: 'actions', loadingStateType: 'medium-text', title: 'Actions', width: 120, sort: null},
        ];
        
        this_component.tableSorting = {};
        this_component.tableColumns.map( (headerCell, index) => { this_component.tableSorting[headerCell.id] = headerCell.sort } );
        
        var sortKey = ('sortKey' in search)?search.sortKey:'created_at';
        var sortOrder = ('sortOrder' in search)?search.sortOrder:'desc';
        
        //preset sort if present in query str
        Object.keys( this_component.tableSorting ).forEach(function(key, index) {
            if( this_component.tableSorting[key] !== null) this_component.tableSorting[key] = 'none';
        });
        
        this_component.tableSorting[sortKey] = sortOrder;
        //end
        
        this.state = {
            sortKey: sortKey,
            sortOrder: sortOrder,
            items: [],
            page: 1,
            perPage: 10000,
            //pageCount: 0,
            imgLogoBig: 'logo-big.png',
            isLoading: false,
            isError: false,
            firstload: true,
            searchValue: ('searchValue' in search)?search.searchValue:'',
            searchType: ('searchType' in search)?parseInt(search.searchType):1,
            tableColumns: this_component.tableColumns,
            tableSorting: this_component.tableSorting,
            
            ignoreDidUpdate: false,
            
            user: this_component.user,
            users: {},
        };
        
        this_component.loader = React.createRef();
        
        this.beforeDeleteDatasetEvent = this.beforeDeleteDatasetEvent.bind(this);
        this.afterDeleteDatasetEvent = this.afterDeleteDatasetEvent.bind(this);
        this.errorDeleteDatasetEvent = this.errorDeleteDatasetEvent.bind(this);
        
        this.beforeCloneDatasetEvent = this.beforeCloneDatasetEvent.bind(this);
        this.afterCloneDatasetEvent = this.afterCloneDatasetEvent.bind(this);
        this.errorCloneDatasetEvent = this.errorCloneDatasetEvent.bind(this);
        
        this.beforeFlushDatasetCacheEvent = this.beforeFlushDatasetCacheEvent.bind(this);
        this.afterFlushDatasetCacheEvent = this.afterFlushDatasetCacheEvent.bind(this);
        this.errorFlushDatasetCacheEvent = this.errorFlushDatasetCacheEvent.bind(this);
        
        this.tableVirtualizedBodyRender = this.tableVirtualizedBodyRender.bind(this);
        
        this_component.handleSearchValue = this_component.handleSearchValue.bind(this_component);
        this_component.handleSearchType = this_component.handleSearchType.bind(this_component);
        this_component.onTableSort = this_component.onTableSort.bind(this_component);
        
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
                this_component.forceUpdate();
            }, 100);
        }
        
        return true;
    }
    
    openInNewTab(e,url)
    {
        e.preventDefault();
        e.stopPropagation();
        window.open(url, '_blank', 'noopener,noreferrer');
    }
    
    howToConnect(e)
    {
        e.preventDefault();
        e.stopPropagation();
        
        this.openInNewTab(e, config.texts.url_howtoconnect);
        
        return false;
    }
    
    openUrlInNewTab(e, url)
    {
        e.preventDefault();
        e.stopPropagation();
        
        this.openInNewTab(e, url);
        
        return false;
    }
    
    async loadUsers()
    {
        var users = await Monday.getUsers(this.loader);
        //console.log("loadUsers", users);
        await this.promisedSetState({'users': users});
    }
    
    
    async componentDidMount()
    {
        this.loader.current.showLoader();
        
        ReactDOM.findDOMNode(this).addEventListener('beforeDeleteDataset', this.beforeDeleteDatasetEvent);
        ReactDOM.findDOMNode(this).addEventListener('afterDeleteDataset', this.afterDeleteDatasetEvent);
        ReactDOM.findDOMNode(this).addEventListener('errorDeleteDataset', this.errorDeleteDatasetEvent);
        
        ReactDOM.findDOMNode(this).addEventListener('beforeCloneDataset', this.beforeCloneDatasetEvent);
        ReactDOM.findDOMNode(this).addEventListener('afterCloneDataset', this.afterCloneDatasetEvent);
        ReactDOM.findDOMNode(this).addEventListener('errorCloneDataset', this.errorCloneDatasetEvent);
        
        await this.loadUsers();
        
        await this.refresh();
        await this.promisedSetState({'firstload': false});
        this.loader.current.hideLoader();
        
        
        /*
        //test api request errors
        for(var i=1;i<=10;i++)
        {
            var data = await Monday.apiRequest(`complexity { before after query } 
                        boards( state: all) { 
                          id 
                          name
                          workspace { id name state }
                          items_page(limit:100) {

                            cursor
                            items
                            {
                              id
                              name
                              column_values(types:[dependency]) {
                                column
                                {
                                  id
                                  type
                                  title
                                  settings_str
                                }
                                      ... on DependencyValue {
                                              id
                                  text
                                  type
                                  value
                                  linked_items {
                                    id
                                    name
                                  }
                                  display_value
                                  linked_item_ids
                                      }
                                      }
                            }

                          }
                        }`);
            console.log(i+' data', data);
        }
        */
    }
    
    componentWillUnmount(event)
    {
        ReactDOM.findDOMNode(this).removeEventListener('beforeDeleteDataset', this.beforeDeleteDatasetEvent);
        ReactDOM.findDOMNode(this).removeEventListener('afterDeleteDataset', this.afterDeleteDatasetEvent);
        ReactDOM.findDOMNode(this).removeEventListener('errorDeleteDataset', this.errorDeleteDatasetEvent);
        
        ReactDOM.findDOMNode(this).removeEventListener('beforeCloneDataset', this.beforeCloneDatasetEvent);
        ReactDOM.findDOMNode(this).removeEventListener('afterCloneDataset', this.afterCloneDatasetEvent);
        ReactDOM.findDOMNode(this).removeEventListener('errorCloneDataset', this.errorCloneDatasetEvent);
        
        ReactDOM.findDOMNode(this).removeEventListener('beforeFlushDatasetCache', this.beforeFlushDatasetCacheEvent);
        ReactDOM.findDOMNode(this).removeEventListener('afterFlushDatasetCache', this.afterFlushDatasetCacheEvent);
        ReactDOM.findDOMNode(this).removeEventListener('errorFlushDatasetCache', this.errorFlushDatasetCacheEvent);
    }
    
    async componentDidUpdate(prevProps, prevState)
    {
        var this_component = this;
    
        //console.log("componentDidUpdate ignoreDidUpdate", this_component.state.ignoreDidUpdate, prevState.ignoreDidUpdate );
    
        if( (prevProps.router.search.toString() !== this_component.props.router.search.toString()) )
        {
            
            if(this_component.state.ignoreDidUpdate !== true) 
            {
                const search = Object.fromEntries(this_component.props.router.search.entries());
                //console.log("search changed", search);
                
                var sortKey = ('sortKey' in search)?search.sortKey:'created_at';
                var sortOrder = ('sortOrder' in search)?search.sortOrder:'desc';
        
                await this_component.promisedSetState( {'searchValue': ('searchValue' in search)?search.searchValue:''} );
                await this_component.promisedSetState( {'searchType': ('searchType' in search)?parseInt(search.searchType):1} );
                await this_component.promisedSetState( {'sortKey': sortKey } );
                await this_component.promisedSetState( {'sortOrder': sortOrder } );
                
                //preset sort if present in query str
                var tableSorting = this_component.state.tableSorting;
                Object.keys( tableSorting ).forEach(function(key, index) {
                    if( tableSorting[key] !== null) tableSorting[key] = 'none';
                });

                tableSorting[sortKey] = sortOrder;

                await this_component.promisedSetState({'tableSorting': tableSorting});
                //end
                
                await this_component.refresh();
            }
            else
            {
                await this_component.promisedSetState({'ignoreDidUpdate': false});
            }
        }
        
    }
    
    beforeDeleteDatasetEvent()
    {
        var this_component = this;
        this_component.loader.current.showLoader();
    };
    
    afterDeleteDatasetEvent()
    {
        var this_component = this;
        //console.log("DatasetList catch event afterDeleteDataset", event);
        event.preventDefault();
        event.stopPropagation();
        this_component.refresh();
        this_component.loader.current.hideLoader();
    };
    
    errorDeleteDatasetEvent()
    {
        var this_component = this;
        this_component.loader.current.hideLoader();
    };
    
    
    beforeCloneDatasetEvent()
    {
        var this_component = this;
        this_component.loader.current.showLoader();
    };
    
    afterCloneDatasetEvent()
    {
        var this_component = this;
        //console.log("DatasetList catch event afterDeleteDataset", event);
        event.preventDefault();
        event.stopPropagation();
        this_component.refresh();
        this_component.loader.current.hideLoader();
    };
    
    errorCloneDatasetEvent()
    {
        var this_component = this;
        this_component.loader.current.hideLoader();
    };
    
    
    beforeFlushDatasetCacheEvent()
    {
        var this_component = this;
        this_component.loader.current.showLoader();
    };
    
    afterFlushDatasetCacheEvent()
    {
        var this_component = this;
        //console.log("DatasetList catch event afterDeleteDataset", event);
        event.preventDefault();
        event.stopPropagation();
        this_component.refresh();
        this_component.loader.current.hideLoader();
    };
    
    errorFlushDatasetCacheEvent()
    {
        var this_component = this;
        this_component.loader.current.hideLoader();
    };
    
    async changeOwner(item, selected)
    {
        var this_component = this;
        console.log("changeOwner", item, selected, this_component.state.items);
        
        var data = new FormData();
        data.append('id', item.id);
        data.append('monday_user_id', selected.value);
        data.append('account_id', this_component.state.user.account_id);
        
        try
        {
            var response = await axios.post('/api/v1/dataset/admin_change_owner', data);
            monday.execute("notice", { 
                message: 'Owner has been successfully changed',
                type: "success", // or "error" (red), or "info" (blue)
                timeout: 10000,
            });
            await this_component.refresh();
        }
        catch( error)
        {
            console.log('dataset owner update error', error, error.response);
            //console.error(error);
            await this_component.promisedSetState({'isLoading': false});
            await this_component.promisedSetState({'isError': true});
            this_component.forceUpdate();
        }
    }
    
    async handleChangeOwner(item, selected)
    {
        var this_component = this;
        //console.log('handleChangeOwner', item, selected);
        if(item.user.monday_user_id != selected.value)
        {
            
            var msg = "Are you sure that you want to change the owner to "+selected.label+" in the "+item.name+" data source?";
            
            monday.execute("confirm", {
                message: msg,
                confirmButton: "Change owner", 
                cancelButton: "Cancel", 
                excludeCancelButton: false
            }).then(async (res) => {
                //console.log("confirm", res.data);
                //{"confirm": true}
                if( ('data' in res) && (res.data.confirm===true))
                {
                    await this_component.changeOwner(item, selected);
                }
            });
        }
        return false;
    }
    
    async refresh()
    {
        var this_component = this;
        await this_component.fetchItems();
        /*this_component.$forceUpdate();*/
    }
    
    
    
    async handleSearchValue(value)
    {
        var this_component= this;
        
        await this_component.promisedSetState({'searchValue': value});
        
        await this_component.promisedSetState({'ignoreDidUpdate': true});
        const search = Object.fromEntries(this_component.props.router.search.entries());
        search.searchValue = value;
        this_component.props.router.setSearchParams(search);

        await this_component.refresh();
    }
    
    async handleSearchType(value)
    {
        var this_component= this;
        
        if(value !== this_component.state.searchType)
        {
            await this_component.promisedSetState({'searchType': value});
            
            
            await this_component.promisedSetState({'ignoreDidUpdate': true});
            const search = Object.fromEntries(this_component.props.router.search.entries());
            search.searchType = value;
            this_component.props.router.setSearchParams(search);
            
            await this_component.refresh();
        }
    }
    
    emptyState()
    {
        var this_component= this;
        
        if(this_component.state.searchValue==='' && this_component.state.searchType===1 && this_component.state.items.length===0)
        {
            return (<Flex className="pt-2 pb-2" justify={Flex.justify.CENTER} direction={Flex.directions.COLUMN}>
                    <div className="text-center mt-4">
                        <img src={ '/img/' + this_component.state.imgLogoBig } width="150" height="150" className="d-inline-block align-top mb-2" alt="{config.texts.name}" />
                    </div>

                    <div>
                        <p className="text-center font-weight-bolder mb-0">Welcome to {config.texts.name} app! This allows you to export any monday.com data into {config.texts.short_name} in 3 easy steps:</p>

                        <div className="text-center">
                            <ol className="text-left d-inline-block">
                                <li>Create your first Data Source, select tables and fields you wish to load.</li>
                                <li>Copy / paste Data Source URL into {config.texts.short_name}, use Access Token to authenticate on {config.texts.short_name}.</li>
                                <li>Build graphs and dashboards in {config.texts.short_name} based on the imported monday.com data.</li>
                            </ol>
                        </div>
                    </div>

                    <div className="text-center">
                        <Button onClick={(e) => this_component.routerToAdd(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.SMALL} leftIcon={Add}>Create your first Data Source now</Button>
                    </div>
            </Flex>);
        }
        
        if(this_component.state.searchType===2 && this_component.state.items.length===0)
        {
            return (<Flex className="pt-2 pb-2" justify={Flex.justify.CENTER} direction={Flex.directions.COLUMN}>
                No shared Data Sources
            </Flex>);
        }
        
        else
        {
            return (<Flex className="pt-2 pb-2" justify={Flex.justify.CENTER}>
                Not Data Sources
            </Flex>);
        }
    }
    
    async onTableSort(id, sort)
    {
        var this_component= this;
        
        if(id == this_component.state.sortKey)
        {
            switch(this_component.state.sortOrder)
            {
                case 'asc': sort = 'desc'; break;
                default:
                case 'desc': 
                    sort = 'asc'; 
                break;
            }
        }
        else
        {
            sort = this_component.state.sortOrder;
        }
        
        var tableSorting = this_component.state.tableSorting;
        
        Object.keys(tableSorting).forEach(function(key, index) {
            if(tableSorting[key]!=null) tableSorting[key] = 'none';
        });
        
        tableSorting[id] = sort;
        
        await this_component.promisedSetState({'tableSorting': tableSorting});
        
        await this_component.promisedSetState({'sortKey': id});
        await this_component.promisedSetState({'sortOrder': sort});
        
        await this_component.promisedSetState({'ignoreDidUpdate': true});
        const search = Object.fromEntries(this_component.props.router.search.entries());
        search.sortKey = id;
        search.sortOrder = sort;
        this_component.props.router.setSearchParams(search);
                
        //await this_component.refresh();
        await this_component.sortItems();
    }
    
    async sortItems()
    {
        var this_component= this;
        var sort_changed = false;
        var items = this_component.state.items;
        var key = this_component.state.sortKey;
        
        naturalSort.insensitive = true;
        
        items.sort( (a,b) => naturalSort(a['created_at'],b['created_at']) );
        items.reverse();
        
        items = items.sort( (a,b) => { var res = naturalSort(a[key],b[key]); if(res !==0) sort_changed=true; return res;} );
        
        if(this_component.state.sortOrder === 'desc' && sort_changed)
        {
            items.reverse();
        }
        
        await this_component.promisedSetState({'items': [...items]});
        
        this_component.forceUpdate();
    }
    
    async fetchItems()
    {
        var this_component= this;

        var data = {};
        data['page'] = this_component.state.page;
        data['perPage'] = this_component.state.perPage;
        data['sortKey'] = this_component.state.sortKey;
        data['sortOrder'] = this_component.state.sortOrder;
        data['search'] = this_component.state.searchValue;
        //data['type'] = this_component.state.searchType;
        
        var url = '/api/v1/dataset/list';
        if(this_component.state.searchType==2)
        {
            if(this_component.state.user.is_admin == true)
            {
                url = '/api/v1/dataset/admin_list';
            }
            else
            {
                url = '/api/v1/dataset/shared_list';
            }
        }

        await this_component.promisedSetState({'isLoading': true});
        this_component.forceUpdate();
        
        try
        {
            var response = await axios.get(url, { 'params': data} );
            
            var items = response.data.items.map( (item, index) => {
                //console.log('item', index, item);
                item.user_name = '';
                if(item.user.monday_user_id in this_component.state.users)
                {
                    item.user_name = this_component.state.users[item.user.monday_user_id].name;
                }
                return item;
            });
            
            //console.log('items', items);
            await this_component.promisedSetState({'items': [...items]});
            await this_component.sortItems();
            //await this_component.promisedSetState({'pageCount': response.data.pageCount});
            await this_component.promisedSetState({'isLoading': false});
            
            if(this_component.state.isError == true)
            {
                await this_component.promisedSetState({'isError': false});
            }
            
            this_component.forceUpdate();
        }
        catch( error)
        {
            console.log('dataset list error', error, error.response);
            //console.error(error);
            await this_component.promisedSetState({'isLoading': false});
            await this_component.promisedSetState({'isError': true});
            this_component.forceUpdate();
        }
    }
    
    getExportUrl(item)
    {
        return window.location.protocol+'//'+window.location.hostname + config.app_core_export_url + '/'+item.hash;
    }
    
    routerToEdit(id, event)
    {
        var this_component= this;
        //this.props.router('/dataset/edit/'+id);
        this.props.router.navigate("/edit/"+id, {'state': {'back': Object.fromEntries(this_component.props.router.search.entries()) } });
    }
    
    routerToAdd(event)
    {
        var this_component= this;
        //this.props.router('/dataset/add');
        
        this.props.router.navigate("/add", {'state': {'back': Object.fromEntries(this_component.props.router.search.entries()) } });
    }
    
    copy(item)
    {
        //console.log('copy',e);
        copyTextToClipboard( this.getExportUrl(item) );
    }
    
    tableCellOwnerContent(item)
    {
        var this_component= this;
        if(this_component.state.user.is_admin == true)
        {
            
            var options = [];
            
            Object.keys(this_component.state.users).forEach(function(key, index) {
                var user = this_component.state.users[key];
                
                //skip inactive accounts
                if(user.enabled===false) return 0;
                
                options.push({'label': user.name,'value': parseInt(user.id)});
            });
            
            //console.log("options",options);
            var selected = {'id': item.user.monday_user_id, 'name': 'Deleted user'};
            if(item.user.monday_user_id in this_component.state.users)
            {
                selected = {... this_component.state.users[item.user.monday_user_id]};
                if(selected.enabled === false) 
                {
                    selected.name = 'Inactive: ' + selected.name;
                }
            }
            
            return (
                <Dropdown 
                    options={options}
                    className="dropdown"
                    dropdownMenuWrapperClassName="dropdownpopupmenu"
                    size={Dropdown.sizes.SMALL}
                    value={[ {'label':selected.name,'value':selected.id} ]}
                    clearable={false}
                    autoFocus={false}
                    maxMenuHeight={200}
                    onChange={ (selected) => this_component.handleChangeOwner(item, selected) }
                    menuPosition={Dropdown.menuPositions.FIXED}
                />
            );
        }
        else
        {
            return ( 
                (item.user.monday_user_id in this_component.state.users)?this_component.state.users[item.user.monday_user_id].name:item.user.monday_user_id
            );
        }
    }
    
    tableVirtualizedBodyRender(item)
    {
        //console.log("tableVirtualizedBodyRender", item);
        var this_component = this;
        var refDiagram = React.createRef();
        var refShare = React.createRef();
        var refShareItemMenu = React.createRef();
        var refFlushDatasetCache = React.createRef();
        var refDelete = React.createRef();
        var refClone = React.createRef();
        return (
            <TableRow key={'tablerow'+item.id}>
                <TableCell className="tableCellFixHeight">{item.name}</TableCell>
                <TableCell className="tableCell tableCellFixHeight">{this_component.tableCellOwnerContent(item)}</TableCell>
                <TableCell className="tableCellFixHeight">{moment(item.created_at).format("YYYY-MM-DD HH:mm")}</TableCell>
                <TableCell className="tableCellFixHeight">{moment(item.updated_at).format("YYYY-MM-DD HH:mm")}</TableCell>
                <TableCell className="tableCellFixHeight">{item.description}</TableCell>
                <TableCell className="tableCellFixHeight">{this_component.getExportUrl(item)}</TableCell>
                <TableCell className="tableCellFixHeight">
                    
                    <Tooltip content={"Copy link"} position={Tooltip.positions.BOTTOM}>
                        <Button onClick={(e) => this_component.copy(item)} type={Button.inputTags.BUTTON} kind={Button.kinds.SECONDARY} size={Button.sizes.SMALL} marginRight={true}><Duplicate /></Button>
                    </Tooltip>
                    
                    {(this_component.state.searchType!=2 || this_component.state.user.is_admin == true) ?
                    null
                    :
                    <Tooltip content={"Preview ERD"} position={Tooltip.positions.BOTTOM}>
                        <Button onClick={ (e) => refDiagram.current.openPopup() } type={Button.inputTags.BUTTON} kind={Button.kinds.SECONDARY} size={Button.sizes.SMALL} marginLeft={false}><Basic /></Button>
                    </Tooltip>
                    }
                    
                    <DatasetDiagram ref={refDiagram} hash={item.hash} />
                    <DatasetShare ref={refShare} openModalButtonRef={refShareItemMenu} id={item.id} />
                    <FlushDatasetCache ref={refFlushDatasetCache} id={item.id} />
                    <DatasetDelete ref={refDelete} id={item.id} />
                    <DatasetClone ref={refClone} id={item.id} />
                    
                    {(this_component.state.searchType!=2 || this_component.state.user.is_admin == true) ?
                    <MenuButton closeMenuOnItemClick dialogPaddingSize="small" size={MenuButton.sizes.SMALL}>
                        <Menu size={Menu.sizes.SMALL}>
                            <MenuItem icon={Basic} title="Preview ERD" onClick={ () => refDiagram.current.openPopup() } />
                            <MenuItem icon={Share} title="Share" ref={refShareItemMenu} onClick={ () => refShare.current.showModal() }/>
                            <MenuItem icon={Edit} title="Edit" onClick={(e) => this_component.routerToEdit(item.id, e)} />
                            <MenuItem icon={Versioning} title="Clear cache" onClick={ () => refFlushDatasetCache.current.flushDatasetCache() } />
                            <MenuItem icon={File} title="Clone" onClick={ () => refClone.current.datasetClone() } />
                            <MenuItem icon={Delete} iconWrapperClassName="icon_delete" title="Delete" onClick={ () => refDelete.current.datasetDelete() } />
                        </Menu>
                    </MenuButton>
                    :null
                    }
                    
                </TableCell>
            </TableRow>
        );
    }
    
    render()
    {
        var this_component = this;
        //console.log("List",this_component.state.items);
        
        return (
                <Loader ref={this_component.loader}>

                            <div className="divTable">
                                <div className="divTableRow">
                                
                                    <Notification id="howToConnect" backgroundColor="var(--primary-selected-color)">
                                        <Info style={{ 'verticalAlign': 'top' }} /> Guide: <Link text={"How to connect to " + config.texts.external_name + "?"} href={config.texts.url_howtoconnect} inlineText onClick={(e) => this_component.howToConnect(e)} />
                                    </Notification>
                                    
                                    <Announcements/>

                                    <Flex className="mb-2" gap={Flex.gaps.SMALL}>
                                        <Button onClick={(e) => this_component.routerToAdd(e)} type={Button.inputTags.BUTTON} kind={Button.kinds.PRIMARY} size={Button.sizes.MEDIUM} leftIcon={Add}>Create a Data Source</Button>

                                        <div style={{'height': '40px'}}>
                                            <Divider direction={Divider.directions.VERTICAL} />
                                        </div>

                                        <Search placeholder="Search" wrapperClassName="col-4 pl-0 pr-0" debounceRate={1000} value={this_component.state.searchValue} onChange={ (value)=> this_component.handleSearchValue(value) } />
                                        
                                        <ButtonGroup
                                            size={ButtonGroup.sizes.MEDIUM}
                                            onSelect={ (value,name) => { this_component.handleSearchType(value);} }
                                            options={[
                                              {
                                                text: 'My Data Sources',
                                                value: 1,
                                              },
                                              {
                                                text: 'Shared With Me',
                                                value: 2
                                              }
                                            ]}
                                            value={this_component.state.searchType}
                                        />
                                    </Flex>
                                </div>
                                
                                <div  className="divTableRowAllHeight">
                                    <Table dataState={{ isLoading: this_component.state.isLoading, isError: this_component.state.isError }} errorState={<Flex className="mt-2 mb-2" justify={Flex.justify.CENTER}>Error on getting data</Flex>} emptyState={this_component.emptyState()} className="tableVirtualizedBody" columns={this_component.state.tableColumns} >
                                        <TableHeader>
                                            {this_component.state.tableColumns.map((headerCell, index) => <TableHeaderCell key={index} title={headerCell.title} onSortClicked={headerCell.sort?sortState => this_component.onTableSort(headerCell.id, sortState):null} sortState={this_component.state.tableSorting[headerCell.id]} />)}
                                        </TableHeader>

                                        <TableBody items={this_component.state.items}>
                                            {this_component.state.items.map( item => this_component.tableVirtualizedBodyRender(item) )}
                                        </TableBody>

                                    </Table>
                                </div>
                            </div>
                </Loader>
        );
    }
}

DatasetList.defaultProps = {};

export default withRouter(withAuth(DatasetList));
